export { default as useIsClient } from './useIsClient';
export * from './useIsClient';
//# sourceMappingURL=index.js.map